import EditAssignmentSchedule from './EditAssignmentSchedule';

export default EditAssignmentSchedule;
